import AmiraGreeting from './amira_initial_greeting.svg';
import AmiraGreeting2 from './amira_initial_greeting2.svg';
import AmiraDefault from './amira_default.svg';

import AmiraSuccess from './amira_action_success.svg';
import AmiraFailure from './amira_action_failed.svg';

import AmiraViewReportDefault from './amira_view_report_default.svg';
import AmiraViewReportAlertModalOpen from './amira_view_report_alert_modal_open.svg';

import AmiraReviewStudentDefault from './amira_review_student_default.svg';
import AmiraReviewStudentAlertModalOpen from './amira_review_student_alert_modal_open.svg';

import AmiraGrowthDefault from './amira_growth_default.svg';
import AmiraGrowthAlertModalOpen from './amira_growth_alert_modal_open.svg';

import AmiraCelebrationDefault from './amira_celebration_default.svg';
import AmiraCelebrationAlertModalOpen from './amira_celebration_alert_modal_open.svg';

import AmiraSystemStatusDefault from './amira_system_status_default.svg';
import AmiraSystemStatusAlertModalOpen from './amira_system_status_alert_modal_open.svg';

import AmiraPDDefault from './amira_pd_default.svg';
import AmiraPDAlertModalOpen from './amira_pd_alert_modal_open.svg';

export {
  AmiraGreeting,
  AmiraGreeting2,
  AmiraDefault,
  AmiraSuccess,
  AmiraFailure,
  AmiraViewReportDefault,
  AmiraViewReportAlertModalOpen,
  AmiraReviewStudentDefault,
  AmiraReviewStudentAlertModalOpen,
  AmiraGrowthDefault,
  AmiraGrowthAlertModalOpen,
  AmiraCelebrationDefault,
  AmiraCelebrationAlertModalOpen,
  AmiraSystemStatusDefault,
  AmiraSystemStatusAlertModalOpen,
  AmiraPDDefault,
  AmiraPDAlertModalOpen,
};
